import type { PatchCaseUpdateBody } from '@packages/clients';

import type { TechlineCaseEntity } from '../entities';

import { StsBackendOperation } from '../../../sts-backend-operation';
import { buildCaseUpdateBody } from '../helpers';

/** Parameters for updating a techline case. */
export type UpdateCaseParams = {
    /** The case number to update. */
    caseNumber: string;

    /** The retailer number associated with the case. */
    retailerNumber: string | undefined;

    /** The current case data to persist. */
    techlineCaseData: TechlineCaseEntity;

    /** The username making the update. */
    username: string;

    /** The VIN associated with the case. */
    vin: string | undefined;
};

/**
 * Update a techline case by building the update payload and calling the
 * NorthStar case API. Returns whether the update succeeded.
 */
export class UpdateCase extends StsBackendOperation {
    /**
     * Build the update payload and persist the case via the API.
     *
     * @param params - the case data and identity fields
     * @returns true if the update succeeded
     */
    async exec(params: UpdateCaseParams): Promise<boolean> {
        const updateBody = buildCaseUpdateBody(params) as PatchCaseUpdateBody;
        const response = await this.client.updateCase({ updateBody });
        return Boolean(response?.success);
    }
}
